@for (data of items.medias; track data) {
<div class="shim-cards-item">
  <div class="shim-cards-header">
    <div class="shim-cards-icon">
      <mat-icon class="material-icons-sharp light" svgIcon="pdf"></mat-icon>
    </div>
    <div class="shim-cards-title-wrapper">
      <div class="shim-cards-title">{{ data.typeName }}</div>
      <div class="shim-cards-description">
        {{ data.title }}
      </div>
    </div>
  </div>
  <div class="shim-cards-content">
    {{ data.shortDescription }}
  </div>
  <div class="shim-cards-footer">
    @if (data.media && data.media.indexOf('/medias') === 0) {
    <a
      [href]="backendURL + data.media"
      download=""
      rel="noopener noreffer"
      target="_blank"
      type="application/octet-stream"
      >{{ 'download.downloadMediaLabel' | cxTranslate }}
      <mat-icon class="light" svgIcon="exportfile"></mat-icon>
    </a>
    } @else {
    <a [href]="data.media" download="" rel="noopener noreffer" target="_blank" type="application/octet-stream"
      >{{ 'download.downloadMediaLabel' | cxTranslate }}
      <mat-icon class="light" svgIcon="exportfile"></mat-icon>
    </a>
    }
  </div>
</div>
}
